import React from 'react';
import PropTypes from 'prop-types';

import { clickAsLink } from 'helpers/link_helpers';

export default function ImportsRow({ importObject }) {
  const goToImport = (event) => {
    clickAsLink(window, importObject.importPath, event);
  };

  return (
    <tr className="clickable-row" onClick={goToImport}>
      <td>{importObject.name}</td>
      <td>{importObject.status}</td>
    </tr>
  );
}

ImportsRow.propTypes = {
  importObject: PropTypes.shape({
    name: PropTypes.string,
    status: PropTypes.string,
    importPath: PropTypes.string
  }).isRequired,
};
